'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = require('copy-to-clipboard');

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CopyToClipboard = _react2.default.createClass({
  displayName: 'CopyToClipboard',

  propTypes: {
    text: _react2.default.PropTypes.string.isRequired,
    children: _react2.default.PropTypes.element.isRequired,
    onCopy: _react2.default.PropTypes.func,
    options: _react2.default.PropTypes.shape({
      debug: _react2.default.PropTypes.bool,
      message: _react2.default.PropTypes.string
    })
  },

  onClick: function onClick(event) {
    var _props = this.props,
        text = _props.text,
        onCopy = _props.onCopy,
        children = _props.children,
        options = _props.options;


    var elem = _react2.default.Children.only(children);

    var result = (0, _copyToClipboard2.default)(text, options);

    if (onCopy) {
      onCopy(text, result);
    }

    // Bypass onClick if it was present
    if (elem && elem.props && typeof elem.props.onClick === 'function') {
      elem.props.onClick(event);
    }
  },
  render: function render() {
    var _props2 = this.props,
        _text = _props2.text,
        _onCopy = _props2.onCopy,
        _options = _props2.options,
        children = _props2.children,
        props = _objectWithoutProperties(_props2, ['text', 'onCopy', 'options', 'children']);

    var elem = _react2.default.Children.only(children);

    return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
  }
});
exports.CopyToClipboard = CopyToClipboard;
//# sourceMappingURL=Component.js.map


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-copy-to-clipboard/lib/Component.js
// module id = 1222
// module chunks = 0 3 5